import { render, staticRenderFns } from "./NormalSearchNav352.vue?vue&type=template&id=56006b06&scoped=true"
import script from "./NormalSearchNav352.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav352.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56006b06",
  null
  
)

export default component.exports